const Collections = {
	manufacturers: "manufacturers",
	models: "models",
	partsPricing: "parts_pricing",
	users: "users",
	orders: "orders",
	prices: "prices",
	services: "services",
	systems: "systems",
	templates: "templates",
	companies: "companies",
	changeLogs: "change_logs",
};

export { Collections };
